const pageConfig = [{
	name: 'PC',
	prefix: 'PC'
},{
	name: 'iOS',
	prefix: 'iOS'
},{
	name: 'Android',
	prefix: 'ANDROID'
}]
//设备选择切换->副标题切换->步骤->是礼物
module.exports = pageConfig;


// WEBPACK FOOTER //
// ./js/pageConfig.js